module.exports = __webpack_public_path__ + "img/watch.84bca207.svg";